(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marshear-banners"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('marshear-banners')) {
    customElements.define('marshear-banners', class extends HTMLElement {
      connectedCallback() {
        if (!this.hasAttribute('data-carousel')) return;
        this.track = this.querySelector('.md-banners__inner');
        this.slides = [...this.track.querySelectorAll('.md-banner')];
        this.selectors = [...this.querySelectorAll('[data-slide-index]')];
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        this.count = this.querySelector('[data-slide-count]');
        this.current = 0;
        this.events = new AbortController();
        const options = {signal: this.events.signal};
        this.querySelector('.md-banner-controls').hidden = false;
        this.selectors.forEach((button, index) => button.addEventListener('click', () => this.goTo(index), options));
        this.previous.addEventListener('click', () => this.goTo(this.current - 1), options);
        this.next.addEventListener('click', () => this.goTo(this.current + 1), options);
        this.track.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.goTo(this.current + (event.key === 'ArrowRight' ? 1 : -1));
        }, options);
        this.track.addEventListener('scroll', () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            const offset = this.track.scrollLeft;
            const closest = this.slides.reduce((best, slide, index) => Math.abs(slide.offsetLeft - offset) < Math.abs(this.slides[best].offsetLeft - offset) ? index : best, 0);
            this.update(closest);
          });
        }, {...options, passive: true});
        this.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index !== -1) this.goTo(index, true);
        }, options);
        this.observer = new ResizeObserver(() => this.goTo(this.current, true));
        this.observer.observe(this.track);
        this.update(0);
      }
      goTo(index, instant = false) {
        index = Math.max(0, Math.min(index, this.slides.length - 1));
        this.track.scrollTo({left: this.slides[index].offsetLeft, behavior: instant || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }
      update(index) {
        this.current = index;
        this.slides.forEach((slide, position) => { slide.inert = position !== index; });
        this.selectors.forEach((button, position) => {
          if (position === index) button.setAttribute('aria-current', 'true');
          else button.removeAttribute('aria-current');
        });
        this.previous.disabled = index === 0;
        this.next.disabled = index === this.slides.length - 1;
        this.count.textContent = `${index + 1} / ${this.slides.length}`;
      }
      disconnectedCallback() {
        this.events?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marshear-catalog-preview"] && !Shopify.designMode) return;
  try {
    
class MarshearPreview {
 constructor(root){this.root=root;this.products=[...root.querySelectorAll('.mcp-data')].flatMap(e=>JSON.parse(e.textContent));this.lang=JSON.parse(root.querySelector('.mcp-language').textContent);this.dialog=root.querySelector('.mcp-dialog');this.lastFocus=null;root.querySelectorAll('[data-product]').forEach(b=>b.addEventListener('click',()=>this.open(b.dataset.product,b)));root.querySelectorAll('[data-brand-filter]').forEach(b=>b.addEventListener('click',()=>this.filter(b)));this.dialog.querySelector('.mcp-close').addEventListener('click',()=>this.dialog.close());this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const b=this.dialog.getBoundingClientRect();if(e.clientX<b.left||e.clientX>b.right||e.clientY<b.top||e.clientY>b.bottom)this.dialog.close()}});this.dialog.addEventListener('close',()=>{document.documentElement.classList.remove('mcp-lock');this.lastFocus?.focus()});}
 filter(button){const brand=button.dataset.brandFilter;this.root.querySelectorAll('[data-brand-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));let count=0;this.root.querySelectorAll('.mcp-card').forEach(c=>{c.hidden=brand!=='all'&&c.dataset.brand!==brand;if(!c.hidden)count++});this.root.querySelector('.mcp-count').textContent=count+' products';}
 open(id,button){const p=this.products.find(p=>p.id===id);if(!p)return;this.lastFocus=button;this.dialog.querySelector('h2').textContent=p.display;this.dialog.querySelector('.mcp-brand').textContent=p.brand;this.dialog.querySelector('.mcp-description p').textContent=p.desc;const im=this.dialog.querySelector('.mcp-detail-img');im.hidden=!p.image;if(p.image){im.src=p.image;im.alt=p.name;}this.dialog.querySelector('.mcp-placeholder').hidden=Boolean(p.image);this.dialog.querySelector('.mcp-version').hidden=!p.hold;const options=this.dialog.querySelector('.mcp-options');options.replaceChildren();p.variants.forEach((v,i)=>{const b=document.createElement('button');b.type='button';b.textContent=v.size;b.setAttribute('aria-pressed',String(i===0));b.addEventListener('click',()=>this.variant(p,i));options.append(b)});this.variant(p,0);this.dialog.showModal();document.documentElement.classList.add('mcp-lock');this.dialog.scrollTop=0;}
 variant(p,i){const v=p.variants[i];this.gallery(p,v);this.dialog.querySelector('.mcp-detail-price').textContent='RM'+v.price.toFixed(2);this.dialog.querySelectorAll('.mcp-options button').forEach((b,n)=>b.setAttribute('aria-pressed',String(n===i)));this.dialog.querySelector('.mcp-availability').textContent=p.hold?this.lang.version:v.stock>0?this.lang.stock:this.lang.sold_out;this.dialog.querySelector('.mcp-buy').textContent=!p.hold&&v.stock===0?this.lang.sold_out:this.lang.preview_only;}
 gallery(p,v){const urls=[...new Set([v.image||p.image,...(p.secondary||[])].filter(Boolean))];const thumbs=this.dialog.querySelector('.mcp-thumbnails');thumbs.replaceChildren();thumbs.hidden=urls.length<2;const main=this.dialog.querySelector('.mcp-detail-img');main.hidden=!urls.length;this.dialog.querySelector('.mcp-placeholder').hidden=Boolean(urls.length);const show=index=>{main.src=urls[index];main.alt=p.name+' — '+this.lang.image+' '+(index+1);thumbs.querySelectorAll('button').forEach((b,n)=>b.setAttribute('aria-pressed',String(n===index)))};urls.forEach((url,index)=>{const b=document.createElement('button');b.type='button';b.setAttribute('aria-label',this.lang.image+' '+(index+1));b.setAttribute('aria-pressed',String(index===0));const thumbnail=document.createElement('img');thumbnail.src=url;thumbnail.alt='';thumbnail.width=64;thumbnail.height=64;b.append(thumbnail);b.addEventListener('click',()=>show(index));thumbs.append(b)});if(urls.length)show(0);}
}
document.querySelectorAll('.mcp-wrap').forEach(root=>{if(!root.dataset.ready){root.dataset.ready='true';new MarshearPreview(root)}});
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.mcp-wrap').forEach(root=>{if(!root.dataset.ready){root.dataset.ready='true';new MarshearPreview(root)}}));

  } catch(e) { console.error(e); }
})();
})();
